module.exports = __webpack_public_path__ + "assets/img/xd_img.93d9de56.png";